import React from 'react';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@material-ui/core';

export default function AppLink(props: MuiLinkProps & { children: any }) {
  return <MuiLink {...props} />;
}
